import React from "react";

const Botom = () => {
  return (
    <div className="bottom--foot justify-content-center lh-sm py-4">
      <div className="d-flex container bottom--foot--top">
        <div className="d-none d-md-flex">
          <p>
            <span>Amazon Music</span>
            <br />
            Stream millions of songs
          </p>
          <p>
            {" "}
            <span>Amazon Business</span>
            <br />
            Everything For Your Business
          </p>
          <p>
            <span>Ring</span>
            <br />
            Smart Home Security Systems
          </p>
          <p>
            {" "}
            <span>IMD Movies</span>
            <br />, TV & Celebrities
          </p>
        </div>
        <div className="d-none d-md-flex">
          <p>
            <span>Amazon Ads</span>
            <br />
            Reach customers wherever they spend their time
          </p>
          <p>
            <span>IMDbPro</span>
            <br />
            Ship Orders Internationally
          </p>
          <p>
            <span>AmazonGlobal</span>
            <br />
            Get Info Entertainment Professionals Need
          </p>
          <p>
            <span>eero WiFi</span>
            <br />
            Stream 4K Video in Every Room{" "}
          </p>
        </div>
        <div>
          <p>
            <span>6pm</span>
            <br />
            Score deals on fashion brands{" "}
          </p>
          <p>
            <span>Home Services</span>
            <br />
            Experienced Pros Happiness Guarantee
          </p>
          <p>
            <span>Kindle Direct Publishing</span>
            <br />
            Publishing Indie Digital & Print Publishing Made Easy
          </p>
          <p>
            <span>Blink</span>
            <br />
            Smart Security for Every Home
          </p>
        </div>
        <div>
          <p>
            <span>AbeBooks</span>
            <br />
            Books, art & collectibles{" "}
          </p>
          <p>
            <span>Amazon Web Services</span>
            <br />
            Services Scalable Cloud Computing Services{" "}
          </p>
          <p>
            <span>Prime Video Direct</span>
            <br />
            Video Distribution Made Easy{" "}
          </p>
          <p>
            <span>Neighbors App</span>
            <br />
            Real-Time Crime & Safety Alerts
          </p>
        </div>
        <div>
          <p>
            <span>ACX</span>
            <br />
            Audiobook Publishing Made Easy
          </p>
          <p>
            <span>Audible</span>
            <br />
            Listen to Books & Original Audio Performances
          </p>
          <p>
            <span>Shopbop</span>
            <br />
            Designer Fashion Brands
          </p>
          <p>
            <span>Amazon Subscription Boxes</span>
            <br />
            Top subscription boxes – right to your door
          </p>
        </div>
        <div>
          <p>
            <span>Sell on Amazon</span>
            <br />
            Start a Selling Account
          </p>
          <p>
            <span>Box Office Mojo</span>
            <br />
            Find Movie Box Office Data{" "}
          </p>
          <p>
            <span>Woot!</span>
            <br />
            Deals and Shenanigans
          </p>
          <p>
            <span>PillPack</span>
            <br />
            Pharmacy Simplified{" "}
          </p>
        </div>
        <div>
          <p>
            <span>Veeqo</span>
            <br /> Shipping Software Inventory Management
          </p>
          <p>
            <span>Goodreads</span>
            <br />
            Book reviews & recommendations
          </p>
          <p>
            <span>Zappos</span>
            <br />
            Shoes & Clothing
          </p>
        </div>
      </div>
      <div className="container last--container">
        <ul className=" last--ul lh-sm gap-3 d-flex list-unstyled text-light justify-content-center">
          <li>Conditions of Use</li>
          <li>Privacy Notice</li>
          <li>Consumer Health Data Privacy Disclosure</li>
          <li>Your Ads Privacy Choices</li>
        </ul>

        <p className="text-center text-light">
          © 1996-2024, Amazon.com, Inc. or its affiliates
        </p>
      </div>
    </div>
  );
};

export default Botom;
